import React from 'react';
import './ColorSwatchGroup.css';

/**
 * ColorSwatchGroup — toggle-кнопки в виде цветных swatch-ей с образцом
 * текста. Используется когда выбор семантически про цвет печати —
 * семантика свотча: «фон цвета X, текст цвета Y» (например для Black
 * swatch фон чёрный, буквы белые — как будет выглядеть напечатанный
 * чёрный текст-печать). Светлые swatch-и получают тонкую inset-тень
 * для видимости на белом фоне sidebar-а.
 *
 * @param {object} props
 * @param {string} props.value — текущее выбранное значение.
 * @param {(value: string) => void} props.onChange — handler смены.
 * @param {Array<{value, bg, textColor, sample?, ariaLabel?}>} props.options
 *   - `bg` — CSS color фона swatch-а.
 *   - `textColor` — CSS color буквы-образца (контраст к bg).
 *   - `sample` (default `Aa`) — текст-образец внутри swatch-а.
 *   - `ariaLabel` — текст для screen-reader и `title` (native tooltip).
 * @param {string} [props.ariaLabel] — общий label для radiogroup.
 * @param {string} [props.className] — дополнительный CSS класс.
 */
export const ColorSwatchGroup = ({
  value,
  onChange,
  options,
  ariaLabel,
  className = '',
}) => (
  <div
    className={`color-swatch-group ${className}`}
    role="radiogroup"
    aria-label={ariaLabel}
  >
    {options.map((opt) => {
      const isActive = opt.value === value;
      const label = opt.ariaLabel || opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={isActive}
          aria-label={label}
          title={label}
          className={`color-swatch-group__swatch${isActive ? ' color-swatch-group__swatch--active' : ''}`}
          style={{ '--swatch-bg': opt.bg, '--swatch-fg': opt.textColor }}
          onClick={() => onChange?.(opt.value)}
        >
          <span className="color-swatch-group__sample">{opt.sample || 'Aa'}</span>
        </button>
      );
    })}
  </div>
);

export default ColorSwatchGroup;
